import React from 'react';
import {
  Pagination,
  PaginationItem,
  Box,
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent
} from '@mui/material';
import {
  ArrowLeftStraight,
  ArrowRightStraight
} from '@components/icons/svg-icon.tsx';

interface PaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  onRowsPerPageChange: (event: SelectChangeEvent<number>) => void;
  rowsPerPageOptions?: number[];
}

const PaginationComponent: React.FC<PaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50, 250, 500, 1000]
}) => {
  return (
    <Box className="flex justify-center items-center mt-3 gap-3">
      <FormControl sx={{ minWidth: 100 }}>
        <Select
          displayEmpty
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
          sx={{
            '@media (max-width: 1715px)': {
              '& .MuiSelect-select': {
                paddingBottom: '8px',
                paddingTop: '8px'
              }
            }
          }}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Pagination
        count={count}
        page={page}
        onChange={(event, value) => {
          onPageChange(event, value);
        }}
        shape="rounded"
        color="primary"
        renderItem={(item) => (
          <PaginationItem
            slots={{
              previous: () => (
                <Box className="flex items-center gap-2">
                  <ArrowLeftStraight color="primary" className="!w-[9px]" />
                  <span>Previous</span>
                </Box>
              ),
              next: () => (
                <Box className="flex items-center gap-2">
                  <span>Next</span>
                  <ArrowRightStraight color="primary" className="!w-[9px]" />
                </Box>
              )
            }}
            {...item}
          />
        )}
      />
    </Box>
  );
};

export default PaginationComponent;
